export * from './displayresult.component';
